import { Injectable } from '@angular/core';
import { OpdateringNoter } from './opdateringNoter';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class OpdateringNoterService {

    constructor(
        private http: HttpClient
    ) {}

    getUnread90DaysByUser() {
        const url = `[api]/OpdateringNoter/unread90DaysByUser/[userId]`;
        return this.http.get<OpdateringNoter[]>(url);
    }

    postLaeste(ids: number[]) {
        const url = `[api]/OpdateringNoter/laeste/[userId]`;
        return this.http.post<OpdateringNoter[]>(url, ids);
    }

    get90Days() {
        const url = `[api]/OpdateringNoter/90Days`;
        return this.http.get<OpdateringNoter[]>(url);
    }
}
